import { Map } from 'immutable';
import * as authActionTypes from '../auth/AuthActionTypes';
import * as resourcesActionTypes from '../resource/ResourcesActionTypes';
import * as tiersActionTypes from '../tiers/TiersActionTypes';
import * as ChartUtils from '../../utils/ChartUtils';
import * as couponsActionTypes from '../coupons/CouponsActionTypes';
import * as taxesActionTypes from '../taxes/TaxesActionTypes';

export const LOADING_INITIAL_STATE = Map({
  loading: false,
  viewMoreLoading: 0,
  requestsLeftToLoad: 0,
  loadingOrdersAnalytics: false,
  loadingDownloadsAnalytics: false,
});
const getBaseNextLoadingStateToMerge = state => ({ loading: true, requestsLeftToLoad: state.get('requestsLeftToLoad') + 1 });
const getBaseDoneOneRequestStateToMerge = state => ({ loading: false, requestsLeftToLoad: returnZeroIfNegative(state.get('requestsLeftToLoad') - 1) });

export default function loadingReducer(state = LOADING_INITIAL_STATE, action) {
  const firstResourcePathSegment = action && Array.isArray(action.resourcePath) && action.resourcePath[0];

  switch (action.type) {
    case resourcesActionTypes.GET_HOME_ANALYTICS_REQUESTED: {
      const baseNextLoadingState = getBaseNextLoadingStateToMerge(state);
      if (ChartUtils.isHomeAnalyticsRoute(firstResourcePathSegment)) {
        baseNextLoadingState.loadingOrdersAnalytics = true;
        baseNextLoadingState.loading = false;
      }
      if (ChartUtils.isGetAppDownloadsRoute(firstResourcePathSegment)) {
        baseNextLoadingState.loadingDownloadsAnalytics = true;
        baseNextLoadingState.loading = false;
      }
      return state.merge(baseNextLoadingState);
    }
    case resourcesActionTypes.ADD_REQUESTS_LEFT_TO_LOAD:
      return addRequestsLeftToLoad(action, state);
    case resourcesActionTypes.REMOVE_REQUESTS_LEFT_TO_LOAD:
      return removeRequestsLeftToLoad(action, state);
    case resourcesActionTypes.GET_ALL_RESOURCES_REQUESTED:
    case tiersActionTypes.GET_TIERS_REQUESTED:
    case couponsActionTypes.GET_COUPONS_REQUESTED:
    case taxesActionTypes.GET_TAXES_REQUESTED:
    case taxesActionTypes.GET_TAXED_LOCATIONS_REQUESTED:
    case taxesActionTypes.GET_TAXED_PRODUCTS_REQUESTED:
    case taxesActionTypes.GET_TAXED_CATEGORIES_REQUESTED:
    case authActionTypes.LOGIN_REQUESTED:
    case resourcesActionTypes.UPDATE_RESOURCE_REQUESTED:
    case tiersActionTypes.UPDATE_TIER_REQUESTED:
    case couponsActionTypes.UPDATE_COUPON_REQUESTED:
    case taxesActionTypes.UPDATE_TAX_REQUESTED:
    case resourcesActionTypes.ADD_RESOURCE_REQUESTED:
    case tiersActionTypes.ADD_TIER_REQUESTED:
    case couponsActionTypes.ADD_COUPON_REQUESTED:
    case taxesActionTypes.ADD_TAX_REQUESTED:
    case resourcesActionTypes.DELETE_RESOURCE_REQUESTED:
    case tiersActionTypes.DELETE_TIERS_REQUESTED:
    case couponsActionTypes.DELETE_COUPON_REQUESTED:
    case taxesActionTypes.DELETE_TAX_REQUESTED:
    case resourcesActionTypes.UPLOAD_RESOURCE_REQUESTED:
    case resourcesActionTypes.GET_DOWNLOAD_RESOURCE_REQUESTED:
    case resourcesActionTypes.GET_RECENT_ORDERS_REQUESTED:
    case resourcesActionTypes.SET_MODIFIERS_ON_OPTIONS_REQUESTED:
    case resourcesActionTypes.SET_EXISTING_OPTIONS_ON_MODIFIER:
    case resourcesActionTypes.SEND_PUSH_NOTIFICATION:
      return state.merge(getBaseNextLoadingStateToMerge(state));
    case resourcesActionTypes.VIEW_MORE_RESOURCE_REQUESTED:
      return state.merge({ viewMoreLoading: state.get('viewMoreLoading') + 1, requestsLeftToLoad: state.get('requestsLeftToLoad') + 1 });
    case resourcesActionTypes.VIEW_MORE_RESOURCE_SUCCESS:
      return state.merge({ viewMoreLoading: returnZeroIfNegative(state.get('viewMoreLoading') - 1), requestsLeftToLoad: returnZeroIfNegative(state.get('requestsLeftToLoad') - 1) });
    case resourcesActionTypes.GET_ALL_RESOURCES_SUCCESS: {
      const baseDoneOneRequestStateToMerge = getBaseDoneOneRequestStateToMerge(state);
      if (ChartUtils.isHomeAnalyticsRoute(firstResourcePathSegment)) baseDoneOneRequestStateToMerge.loadingOrdersAnalytics = false;
      if (ChartUtils.isGetAppDownloadsRoute(firstResourcePathSegment)) baseDoneOneRequestStateToMerge.loadingDownloadsAnalytics = false;
      return state.merge(baseDoneOneRequestStateToMerge);
    }
    case resourcesActionTypes.GET_DOWNLOAD_RESOURCES_SUCCESS:
    case resourcesActionTypes.UPLOAD_RESOURCE_SUCCESS:
    case resourcesActionTypes.ERROR:
    case authActionTypes.LOGIN_SUCCESS:
    case resourcesActionTypes.UPDATE_RESOURCE_SUCCESS:
    case resourcesActionTypes.ADD_RESOURCE_SUCCESS:
    case resourcesActionTypes.DELETE_RESOURCE_SUCCESS:
    case resourcesActionTypes.GET_RECENT_ORDERS_SUCCESS:
    case resourcesActionTypes.SEND_PUSH_NOTIFICATION_SUCCESS:
      return state.merge(getBaseDoneOneRequestStateToMerge(state));
    case resourcesActionTypes.UPDATE_PAGE_SETTINGS:
      return state;
    case authActionTypes.SIGNOUT_USER:
    default:
      return state.set('loading', false);
  }
}

const returnZeroIfNegative = integer => (integer < 0 ? 0 : integer);


const addRequestsLeftToLoad = (action, state) => state.set('requestsLeftToLoad', state.get('requestsLeftToLoad') + action.numRequests);
const removeRequestsLeftToLoad = (action, state) => state.set('requestsLeftToLoad', state.get('requestsLeftToLoad') - action.numRequests);

